const colors = {
  primary: "#276EF1",
  secondary: "#7356BF",
  success: "#05944F",
  warning: "#FFE975",
  danger: "#E11900",
  white: "#FFFFFF",
  warningDark: "#66512C",
  dark: "#000000",
  info: "#17A2B8",
  light: "#EEEEEE",

  primaryHover: "#276EF1BD",
  secondaryHover: "#7356BFBD",
  successHover: "#05944FBD",
  warningHover: "#FFE975BD",
  dangerHover: "#E11900BD",
  whiteHover: "#FFFFFFD5",
  darkHover: "#000000BD",
  infoHover: "#17A2B8BD",
  lightHover: "#EEEEEEBD",
};

export default colors;
